import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CoverageApi } from '../coverage-api';
import type { IDataIndicator, IGetIndicatorListParams } from '../../types/index';

@injectable()
export class CoverageApiImpl extends PsHttpService implements CoverageApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    // TODO 后端接口待定（表 ads_discovery_data_indicator 在 npd_ads/TiDB，访问方式确认中）
    getIndicatorList(params?: IGetIndicatorListParams) {
        return this.get<PatSnapCommonResponseData<IDataIndicator[]>>({
            url: '/data-coverage/indicators',
            params,
        }).then((res) => {
            return (res.data || []) as IDataIndicator[];
        });
    }
}
